//TODO: As funções de interações de objetos em tela devem ser migradas para modules/ui-events.js
var smlbpms = smlbpms || {};

h.ready(function () {
    smlbpms.setNotificationEvents();
    smlbpms.getTasksCount();
    smlbpms.getMenu();
    smlbpms.setGlobalSearch();
    smlbpms.setLogout();
    smlbpms.setChangeLang();
    smlbpms.getMaintananceMessage();
    smlbpms.checkLicense();
    smlbpms.checkVersion();
    smlbpms.movideskTrack();
    smlbpms.movideskRequest();
    smlbpms.movideskChat();
    smlbpms.announceKitLoad();
    smlbpms.prepareFormToFileUpload();
    smlbpms.setAutosuggests();
    smlbpms.prepareCountryStateCity();
    smlbpms.addFormFieldTokenInstructions();
});

smlbpms.baseUrl = document.body.getAttribute("data-base-url") || "/";

smlbpms.cleanSelectElement = function (selectElement) {
    if (selectElement && selectElement.options) {
        while (selectElement.options.length > 1) {
            selectElement.options[selectElement.options.length - 1] = null;
        }
    }
},

    smlbpms.prepareCountryStateCity = function () {
        var inpCodCountry = document.getElementById("inpCodCountry");

        if (inpCodCountry != null) {
            inpCodCountry.addEventListener("change",
                function () {
                    smlbpms.cleanSelectElement(document.getElementById('inpCodState'));
                    smlbpms.cleanSelectElement(document.getElementById('inpCodCity'));
                    if (this.value != "") {
                        h.getJSON(
                            window.appvars.services.geo.countries.states.replace('{countryId}', this.value),
                            function (data) {
                                h.forEach(data.success, function (key, val) {
                                    var inpCodState = document.getElementById('inpCodState');
                                    if (inpCodState) inpCodState.innerHTML += `<option value="${val.id}">${val.name}</option>`;
                                });
                            }
                        );
                    }
                });
        }

        var inpCodState = document.getElementById("inpCodState");
        if (inpCodState != null) {
            inpCodState.addEventListener('change',
                function () {
                    smlbpms.cleanSelectElement(document.getElementById('inpCodCity'));
                    if (this.value != "") {
                        h.getJSON(
                            window.appvars.services.geo.states.cities.replace('{stateId}', this.value),
                            function (data) {
                                h.forEach(data.success, function (key, val) {
                                    var inpCodCity = document.getElementById('inpCodCity');
                                    if (inpCodCity) inpCodCity.innerHTML += `<option value="${val.id}">${val.name}</option>`;
                                });
                            }
                        );
                    }
                });
        }
    },

    smlbpms.setAutosuggests = function () {
        const inputs = document.querySelectorAll("[data-autosuggest-config]");

        h.forEach(inputs,
            function (i, item) {
                const config = item.getAttribute("data-autosuggest-config");
                item.setAttribute("data-autosuggest-fillwithresult", "true");
                item.setAttribute("data-autosuggest-maxitens", "10");
                item.setAttribute("data-autosuggest-minlength", "3");
                item.setAttribute("data-autosuggest-clientfilter", "false");
                item.setAttribute("type", "search");
                if (!item.getAttribute("placeholder"))
                    item.setAttribute("placeholder", window.appvars.translation.starttyping);

                const currentcoduser = document.getElementById("inpCodUser");
                const currentcoduservalue = currentcoduser && currentcoduser.value !== "" ? currentcoduser.value : null;

                if (config === "allusers")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.users.search}?name=$this", "icon":"user", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "alluserswithnoforceviewall")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.users.search}?name=$this&viewall=false", "icon":"user", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "alluserswithusername")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.users.search}?includeusername=true&name=$this", "icon":"user", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "alluserswithusernamedifferentfromcurrent")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.users.search}?includeusername=true&differentfromcurrentuser=true&name=$this", "icon":"user", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "activeuserswithusername")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.users.search}?isactive=true&includeusername=true&name=$this", "icon":"user", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "activeuserswithusernamedifferentfromcurrent")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.users.search}?isactive=true&includeusername=true&differentfromcurrentuser=true&name=$this", "icon":"user", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "activeuserswithusernamedifferentfromcoduser")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.users.search}?isactive=true&includeusername=true${(currentcoduservalue != null ? `&differentfromcoduser=${currentcoduservalue}` : "")}&name=$this", "icon":"user", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "allareaswithgeo")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.teams.search}?includegeo=true&name=$this", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "allareas")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.teams.search}?includegeo=false&name=$this", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "allfunctions")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.positions.search}?name=$this", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "flowsdeployedwithversion")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.flows.deployed.search}?includeversion=true&name=$this", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "flowsusercanmanage")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.flows.canmanage.search}?name=$this", "text":"nm", "id":"id", "compare":"nm"}]`);
                if (config === "servicesusercanmanage")
                    item.setAttribute("data-autosuggest", `[{"url":"${window.appvars.services.services.canmanage.search}?name=$this", "text":"nm", "id":"id", "compare":"nm"}]`);
                bsml.Autosuggest2.Init(item);
            });
    }

smlbpms.prepareFormToFileUpload = function () {
    const file = document.querySelector("input[type='file']");
    if (file == null) return;

    const form = document.querySelector("form");
    if (form == null) return;

    form.setAttribute("enctype", "multipart/form-data");
}

smlbpms.movideskTrack = function () {
    var container = document.getElementById("containerMovideskMonitor");
    if (container != null) {
        h.addEventListener(container,
            "click",
            function () {
                bsml.toggleSpinner(container, true);
                h.getJSON(
                    window.appvars.services.ui.movidesk.monitor,
                    function (data) {
                        if (data && data.success) {
                            bsml.toggleSpinner(container, false);
                            window.open(data.success);
                        }
                    }
                );
            }
        );
    }
}

smlbpms.movideskRequest = function () {
    var container = document.getElementById("containerMovideskRequest");
    if (container != null) {
        h.addEventListener(container,
            "click",
            function () {
                bsml.toggleSpinner(container, true);
                h.getJSON(
                    window.appvars.services.ui.movidesk.request,
                    function (data) {
                        if (data && data.success) {
                            bsml.toggleSpinner(container, false);
                            window.open(data.success);
                        }
                    }
                );
            }
        );
    }
}

smlbpms.movideskChat = function () {
    const container = document.getElementById("containerMovideskChat");

    if (container != null) {
        h.addEventListener(container,
            "click",
            function () {
                bsml.toggleSpinner(container, true);
                h.getJSON(
                    window.appvars.services.ui.movidesk.chat,
                    function (data) {
                        if (data && data.success) {
                            bsml.toggleSpinner(container, false);
                            bsml.modalOpen(data.success, 2);
                        }
                    }
                );
            });
    }
}

smlbpms.announceKitLoad = function () {
    const btn = document.getElementById("aHeaderMenuHelp");
    const container = document.querySelector(".announcekit-widget");

    if (container != null) {
        h.addEventListener(btn,
            "click",
            function () {
                const announcekitid = container.getAttribute("data-announcekitid");
                const announcekitloaded = container.getAttribute("data-announcekit-loaded");
                const userIsSubstituing = document.querySelector('#userIsSubstituing').value;

                if (announcekitid != null &&
                    announcekitid !== "" &&
                    announcekitloaded != null &&
                    announcekitloaded !== "true" &&
                    userIsSubstituing == 'N') {
                    window.announcekit = (window.announcekit ||
                    {
                        queue: [],
                        on: function (n, x) { window.announcekit.queue.push([n, x]); },
                        push: function (x) { window.announcekit.queue.push(x); }
                    });
                    window.announcekit.push({
                        "widget": `https://announcekit.app/widgets/v2/${announcekitid}`,
                        "selector": ".announcekit-widget",

                        user: {
                            id: document.querySelector('#userId').value,
                            email: document.querySelector('#userEmail').value,
                            //TODO: retirar funcao que remove acentos e caracteres especiais do nome
                            //assim que a api do announcekit possibilitar esse tipo de envio
                            name: removeAccentsAndSpecialCharacters(document.querySelector('#userFirstName').value)
                        },
                        data: {
                            user_persona: document.querySelector('#userPersona').value.toLowerCase(),
                            base_url: smlbpms.baseUrl,
                            product_name: "zeev"
                        }
                    });
                    h.addScript("https://cdn.announcekit.app/widget-v2.js");
                    container.setAttribute("data-announcekit-loaded", "true");
                    bsml.show(container);
                }
            }
        );
    }

    function removeAccentsAndSpecialCharacters(text) {
        return text.normalize('NFD').replace(/[^\w\s]/gi, '');
    }
}

smlbpms.checkVersion = function () {
    var container = document.getElementById("ContainerCanUpdateVersion");
    var btn = document.getElementById("aHeaderMenuHelp");

    if (container != null && btn != null) {
        h.addEventListener(document.getElementById("aHeaderMenuHelp"),
            "click",
            function () {
                h.getJSON(
                    smlbpms.baseUrl + "api/internal/bpms/1.0/appversion/checklatest",
                    function (data) {
                        if (data != null && data.success != null && data.success != false) {
                            if (data.success.canUpgrade) {
                                var container = document.getElementById("containerNewAvalaibleVersion");
                                if (container) {
                                    document.getElementById("containerNewAvalaibleVersion").innerText = data.success.mostRecentVersion;
                                }
                                h.removeClass(document.getElementById("ContainerYesCanUpgrade"), "d-none")
                            } else {
                                h.removeClass(document.getElementById("ContainerCannotUpgrade"), "d-none");
                            }
                        }
                    }
                );
            });
    }
}

smlbpms.getMaintananceMessage = function () {
    var container = document.querySelector(".alert-system-addon");
    if (container != null) {
        h.getJSON(
            window.appvars.services.ui.maintenance.message,
            function (data) {
                if (data != null && data.success != null && data.success != "") {
                    let html = '<div class="alert alert-info" >\
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">×</button>\
                                    <span>{Msg}</span>\
                                </div>';
                    html = html.replace(/{Msg}/gi, data.success);
                    container.insertAdjacentHTML('afterbegin', html);
                    container.style.display = "block";
                }
            }
        );
    }
}

smlbpms.setMicrofrontend = function () {
    h.forEach(document.querySelectorAll("[data-microfrontend='true']"), function (i, item) {
        h.addEventListener(item, "click", function () {
            smlbpms.setMicrofrontend_Click(item);
        });
    });
}

smlbpms.setMicrofrontend_Click = function (el) {
    window.event.preventDefault();

    const container = document.querySelector(".page-content");
    container.innerHTML = "";

    const url = el.getAttribute("href");
    const urlBrowser = url.replace("embed", "apps");

    var html = "";
    html += "    <div id=\"microfrontendSpinner\" class=\"p-2\"><div class=\"spinner\"></div></div>";
    html += `    <iframe name="microfrontendFrame" onload="smlbpms.setMicrofrontend_Load('${urlBrowser}')" class="d-none embed-iframe" id="microfrontendFrame" data-src="" src="${url}"  frameborder="0" width="100%" height="0px" marginheight="0" marginwidth="0"  ></iframe> `;

    container.insertAdjacentHTML('afterbegin', html);
}

smlbpms.setMicrofrontend_Load = function (url) {
    h.removeClass(document.getElementById("microfrontendFrame"), "d-none");
    h.addClass(document.getElementById("microfrontendSpinner"), "d-none");
    bsml.resizeIframes();
}

smlbpms.setGlobalSearch = function () {
    var search = document.getElementById("inpSearch");
    if (search != null) {
        h.getJSON(window.appvars.services.ui.search.config,
            function (data) {
                if (data && data.success) {
                    search.setAttribute("data-autosuggest-minlength", data.success.minlength);
                    search.setAttribute("data-autosuggest-maxitens", data.success.maxitens);
                    search.setAttribute("data-autosuggest-minwidth", "500px");
                    search.setAttribute("data-autosuggest-fillwithresult", false);
                    search.setAttribute("data-autosuggest-clientfilter", false);
                    search.setAttribute("data-autosuggest", JSON.stringify(data.success.configs));
                }
                bsml.Autosuggest2.Init(search);
            });
    }
}

smlbpms.getTasksCount = function () {
    var counters = document.querySelectorAll(".tasks-total-count");
    if (counters.length > 0) {
        h.getJSON(
            window.appvars.services.assignments.countpending,
            function (data) {
                if (data != null && data.success != null) {
                    h.forEach(counters, function (i, item) {
                        item.innerText = data.success;
                        if (data.success !== "0")
                            h.removeClass(item, "d-none");
                    });
                }
            }
        );
    }
}

smlbpms.getMenuCategoryId = function (categoryLink) {
    switch (categoryLink) {
        case '/manage/advanced':
            return 'aSideMenuAdvancedSettings';
        case '/manage/settings':
            return 'aSideMenuConfigSettings';
        default:
    }
}

smlbpms.getMenu = function () {
    var container = document.getElementById("containerMenuAdmin");

    if (container != null && getComputedStyle(container, null).display !== "none") {
        bsml.toggleSpinner(container, true);

        var template_category = '<a id="menu_{Id}" class="nav-link {IsActive}" data-toggle="collapse" href="#submenu_{Id}">\
                                    <i class="ico-{Icon} ico-md"></i>\
                                    {Title}\
                                    <i class="ico-down ico-sm"></i>\
                                </a>';

        var template_category_link = '<a id="{Id}" class="nav-link  {IsActive}"  href="{Link}">\
                                    <i class="ico-{Icon} ico-md"></i>\
                                    {Title}\
                                    <i class="ico-right ico-sm"></i>\
                                </a>';

        var template_item_container = '<div class="collapse submenu" id="submenu_{Id}"></div>'

        var template_item = '<a id="{Id}" class="nav-link {IsActive}" href="{Link}" data-microfrontend="{Micro}" target="{Target}">{Title}</a>';

        h.getJSON(
            smlbpms.baseUrl + "api/internal/bpms/1.0/menu",
            function (data) {
                if (data != null && data.success != null) {
                    if (data.success.length > 0) {
                        container.insertAdjacentHTML('afterbegin', `<h5>${tsml.getTranslation("administration")}</h5>`);
                        container.insertAdjacentHTML('afterbegin', '<div class="menu-divider mt-4 mb-4"></div>');
                    }

                    h.forEach(data.success, function (i, category) {
                        var iscategoryactive = category.l !== "" && location.href.indexOf(category.l) >= 0;

                        var html = category.l === "" ? template_category : template_category_link;
                        html = html.replace(/{Id}/gi, category.l === "" ? category.id : smlbpms.getMenuCategoryId(category.l));
                        html = html.replace(/{Title}/gi, category.t);
                        html = html.replace(/{Icon}/gi, category.i);
                        html = html.replace(/{Link}/gi, category.l);
                        html = html.replace(/{IsActive}/gi, (iscategoryactive ? "active" : ""));

                        container.insertAdjacentHTML('beforeend', html);

                        const container_category = document.getElementById("menu_" + category.id);

                        if (category.its != null && category.its.length > 0) {
                            html = template_item_container;
                            html = html.replace(/{Id}/gi, category.id);
                            container.insertAdjacentHTML('beforeend', html);

                            var container_items = document.getElementById("submenu_" + category.id);

                            h.forEach(category.its, function (j, items) {
                                var isactive = location.href.indexOf(items.l) >= 0;
                                html = template_item;
                                html = html.replace(/{Id}/gi, `aSideMenu${items.a.toLowerCase()}`);
                                html = html.replace(/{Link}/gi, items.l);
                                html = html.replace(/{Title}/gi, items.t);
                                html = html.replace(/{Micro}/gi, items.mf);
                                html = html.replace(/{Target}/gi, (items.o ? "_blank" : ""));
                                html = html.replace(/{IsActive}/gi, (isactive ? "active" : ""));
                                container_items.insertAdjacentHTML('beforeend', html);

                                if (isactive) {
                                    h.addClass(container_items, "show");
                                }
                            });

                            const myCollapseInit = BSN && BSN.Collapse
                                ? new BSN.Collapse(container_category)
                                : new Collapse(container_category);
                        }
                    });

                    bsml.convertIcons(container);
                    bsml.toggleSpinner(container, false);
                    smlbpms.setMicrofrontend();
                }
            }
        );
    }
}

smlbpms.setNotificationEvents = function () {
    smlbpms.notificationCount();

    if (document.querySelector(".notification-box .nav-link")) {
        document.querySelector(".notification-box .nav-link").onclick = function () {
            smlbpms.notificationList(document.querySelector(".notification-itens"),
                "received",
                70,
                1,
                5);
        }
    }
    h.forEach(document.querySelectorAll(".btn-mark-all-as-read"), function (i, item) {
        item.onclick = function () {
            smlbpms.notificationMarkAll(this);
        }
    });

    h.delegateEvent(document.querySelector(".notification-itens"), "click", ".notification-item", smlbpms.notificationClick);
    h.delegateEvent(document.body, "click", ".btn-new-notification", smlbpms.notificationNew);
}

smlbpms.notificationCount = function () {
    var counters = document.querySelectorAll(".notification-count");
    if (counters.length > 0) {
        h.getJSON(
            window.appvars.services.ui.notifications.count,
            function (data) {
                if (data != null && data.success != null) {
                    h.forEach(counters, function (i, item) {
                        item.innerText = data.success;
                        if (data.success !== 0)
                            h.removeClass(item, "d-none");
                    });
                }
            }
        );
    }
}

smlbpms.notificationList = function (container, method, concat, pageNumber, recordsPerPage) {
    if (container != null) {
        var containerEmpty = document.querySelector(".notification-itens-empty");
        var containerControls = document.querySelector(".notification-controls");
        var foundNotification = false;
        bsml.toggleSpinner(container, true);

        const url = method === "sent"
            ? window.appvars.services.ui.notifications.sent
            : window.appvars.services.ui.notifications.received;

        h.getJSON(
            `${url}?concat=${concat}&pageNumber=${pageNumber}&recordsPerPage=${recordsPerPage}`,
            function (data) {
                h.forEach(data.success, function (i, item) {
                    if (container.getAttribute("data-log") != null && container.getAttribute("data-log").indexOf(item.cn + ",") >= 0)
                        return;

                    h.addClass(containerEmpty, "d-none");
                    h.removeClass(containerControls, "d-none");

                    foundNotification = true;

                    let html = "";
                    html += `<a class="notification-item notification-item-${item.cn}  ${!item.ir ? " notification-item-unread" : ""} " href="javascript:void(0)" data-c="${item.ce}">`;
                    html += `    <div class="row">`;
                    html += "        <div class=\"col-1 avatar-lg justify-content-center\">";
                    html += item.dpf;
                    html += "        </div>";
                    html += "        <div class=\"col\" style=\"overflow:hidden\">";
                    html += `            <h5>${item.s}</h5>`;
                    html += `           <span class="text-muted text-ellipsis ">${item.b}</span>`;
                    html += `           <span class="text-info  ml-auto small">${item.dt}</span>`;
                    html += "        </div>";
                    html += "    </div>";
                    html += "</a>";

                    const tmp = document.createElement("div");
                    tmp.innerHTML = html;
                    container.append(tmp.firstChild);

                    container.setAttribute("data-log", (container.getAttribute("data-log") || "") + item.cn + ",");
                });

                if (!foundNotification && containerEmpty && containerEmpty.querySelectorAll("img").length === 0) {
                    containerEmpty.insertAdjacentHTML("afterbegin", `<img src="${smlbpms.baseUrl}common/plugin/orquestra-bootstrap/dist/assets/img/notifications.svg" class="w-50 mt-5">`);
                }

                bsml.convertIcons(container);
                bsml.toggleSpinner(container, false);
            });
    }
}

smlbpms.notificationMarkAll = function (container) {
    bsml.toggleSpinner(container, true);

    h.callWebAPI(
        window.appvars.services.ui.notifications.markall,
        "PATCH",
        null,
        function (data) {
            if (data && data.success) {
                const itens = document.querySelectorAll(".notification-item");

                h.forEach(itens, function (i, item) {
                    h.removeClass(item, "notification-item-unread");
                });

                const counters = document.querySelectorAll(".notification-count");
                h.forEach(counters, function (i, counter) {
                    counter.innerText = "0";
                });
            }

            bsml.toggleSpinner(container, false);
        }
    );
}

smlbpms.notificationClick = function (ev, el) {
    while (el.getAttribute("data-c") == null) {
        el = el.parentNode;
    }

    const c = el.getAttribute("data-c");
    bsml.modalOpen(smlbpms.baseUrl + "my/notification?n=" + c, 2);
    h.removeClass(el, "notification-item-unread");
}

smlbpms.notificationNew = function () {
    const url = `${smlbpms.baseUrl}my/notification?${document.getElementById("inpCodFlowExecute") != null ? `&e=${document.getElementById("inpCodFlowExecute").value}` : ""}`;
    bsml.modalOpen(url, 2);
}

smlbpms.notificationUnread = function (n) {
    var elements = document.querySelectorAll(".notification-item-" + n);
    Array.from(elements).forEach(function (li) {
        li.classList.add("notification-item-unread");
    });
}

///Função duplicada em /Designer/Master/Property.Master.
smlbpms.help = function (url, uid) {
    var helpuid = "";
    if (uid != null) {
        helpuid = uid;
    }
    else if (document.getElementById("inpCodHelpUID") != null) {
        helpuid = document.getElementById("inpCodHelpUID").value;
    }
    url += helpuid !== "" ? `?StepUID={${helpuid}}` : "";
    window.open(url);
}

smlbpms.setLogout = function () {
    var btn = document.getElementById("btnLogout");
    if (btn != null) {
        h.addEventListener(btn, "click", function () {
            var spinner = btn.querySelector(".spinner");

            h.removeClass(spinner, "d-none");
            h.getJSON(smlbpms.baseUrl + "api/internal/bpms/1.0/logout", function (data) {
                if (data != null && data.success != null) {
                    location.href = data.success;
                } else {
                    h.addClass(spinner, "d-none");
                }
            });
        });
    }
}

smlbpms.setChangeLang = function () {
    h.addEventListener(document.querySelectorAll(".change-lang"), "click", function (ev) {
        window.bsml.toggleButtonSpinner(document.querySelector("#aHeaderMenuChangeLanguage"), true);
        const postdata = {
            "lang": this.getAttribute("data-lang")
        };
        h.callWebAPI(
            window.appvars.services.language.set,
            "POST",
            postdata,
            (data) => {
                if (!data.success) return;

                location.reload();
            }
        );
    });
}

smlbpms.checkLicense = function () {
    var container = document.getElementById("containerLicenseInfo");
    const days = document.getElementById("containerLicenseInfoDays");
    const daysInfo = document.getElementById("containerLicenseInfoDaysInfo");
    if (container && daysInfo && days) {
        h.getJSON(
            window.appvars.services.license.daysToExpire,
            function (data) {
                if (data != null && data.success != null) {
                    const days = document.getElementById("containerLicenseInfoDays");
                    const daysInfo = document.getElementById("containerLicenseInfoDaysInfo");

                    // Se for maior que zero e menor que o int.MaxValue c#
                    if (data.success > 0 && data.success < 2147483647) {
                        bsml.show(container);
                        bsml.show(daysInfo);
                        days.innerText = data.success;
                    }
                    else if (window.appvars.params.demo) {
                        bsml.show(container);
                    } else {
                        h.remove(container);
                    }
                }
            }
        );
    }
}

smlbpms.upload = function (folder, showcomment, showrequester) {
    if (showcomment == null) showcomment = "0";
    if (showrequester == null) showrequester = "0";
    const url = `${smlbpms.baseUrl}files/upload?inpDsFolder=${folder}&inpShowComment=${showcomment}&inpShowRequesterCheck=${showrequester}`;
    bsml.modalOpen(url, 3);
}

smlbpms.uploadCrypt = function (c, rowindex) {
    if (rowindex == null) rowindex = -1;

    try {
        var close_modal = parent.document.querySelector('.modal-close');

        // Verifica se já tem um X para fechar o modal anterior e escondee ele para que não crie uma confusão no usuário e acabe fechando a tela errada.
        if (close_modal != null && close_modal.offsetParent !== null) {
            close_modal.style.display = "none";

            var show_close_modal_function = function () { close_modal.style.display = "block"; }
            h.addEventListener(document.querySelector('.modal-close'), "click", show_close_modal_function);
            h.addEventListener(document.querySelector('#dynmodal'), "click", show_close_modal_function);
        }
    } catch (e) {
        //Evitar erro de CORS, quando estiver dentro de um iframe em outro dominio
        let content = window;
        content.parent.postMessage("hide-modal-close", "*");
        var show_close_modal_function = function () {
            content.parent.postMessage("show-modal-close", "*")
        };
        h.addEventListener(document.querySelector('.modal-close'), "click", show_close_modal_function);
        h.addEventListener(document.querySelector('#dynmodal'), "click", show_close_modal_function);
    }

    const url = `${smlbpms.baseUrl}files/upload?c=${c}&i=${rowindex}`;
    bsml.modalOpen(url, 3);
}

smlbpms.closeLegacyModal = function () {
    $.colorbox.close();
}

smlbpms.openPopup = function () {
    // função para encapsular o $.colorbox()
    console.log('Ainda não implementado');
}

smlbpms.addAttribute = (o, att, v) => {
    if (typeof (o) === "string") o = document.querySelector(o);
    if (o)
        o.setAttribute(att, v);
}

smlbpms.openPositionHierarchy = (mode, codarea) => {
    if (mode == null) mode = "edit";
    if (codarea == null) codarea = "";
    const url = `${window.appvars.baseurl}manage/positions-hierarchy?mode=${mode}${(codarea === "" ? "" : `?codarea=${codarea}`)}`;
    bsml.modalOpen(url);
}

smlbpms.openAreaHierarchy = (mode) => {
    if (mode == null) mode = "edit";
    const url = `${window.appvars.baseurl}manage/areas-hierarchy?mode=${mode}`;
    bsml.modalOpen(url);
}

//Invalidar o atributo autocomplete, workaround para Chrome
//única maneira de desligar o autcomplete em algumas paginas especificas
//como no cadastro de usuários
smlbpms.invalidateAutocomplete = () => {
    var fields = document.querySelector("[autocomplete]");

    h.forEach(fields,
        (i, item) => {
            item.setAttribute("autocomplete", "nope");
        });
}

smlbpms.downloadURI = (uri) => {
    var link = document.createElement("a");
    link.download = uri.substr(uri.lastIndexOf('/') + 1, uri.length - uri.lastIndexOf('/'));
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

smlbpms.downloadContent = (fileResult) => {
    let link = document.createElement("a");
    link.download = fileResult.fileName;
    link.href = `data:${fileResult.mimeType};base64,${fileResult.fileContent}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

smlbpms.addFormFieldTokenInstructions = () => {
    h.forEach(document.querySelectorAll("[data-tokens]"),
        function (i, field) {
            const parent = field.parentNode;
            if (parent) {
                parent.insertAdjacentHTML('beforeend', `<a class="form-control-tip" target="_blank" href="https://kb.smlbrasil.com.br/outras-configuracoes-avancadas/dicionario-de-tokens-de-variaveis"><i class="ico-help ico-sm"></i> ${window.appvars.translation.usetokens}</a>`);
                bsml.convertIcons(parent);
            }
        });
}

//compatibilidade com componente externos legados que chamam esse metodo
if (!cryo_resizeIFrame) function cryo_resizeIFrame() { }

